import { type WishlistEntryModel, type WishlistModel } from "~/features/wishlist/types/model";

export interface WishlistPageState {
  loading: boolean;
  loaded: boolean;
  error?: string;
  wishlistIds: string[];
  wishlists: Dictionary<WishlistModel>;
  entries: Dictionary<WishlistEntryModel>;

  selectedWishlistId?: string;
  addAllClicked: boolean;
}

export const wishlistPageInitialState: WishlistPageState = {
  loading: false,
  loaded: false,
  wishlistIds: [],
  wishlists: {},
  entries: {},

  selectedWishlistId: "",
  addAllClicked: false,
};
